var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    [
      _c("v-card-title", [
        _vm._v(
          " Share " +
            _vm._s(_vm.selectedJob[0].parsedMetadata.ModelName) +
            ", " +
            _vm._s(_vm.selectedJob[0].id) +
            " "
        ),
      ]),
      _c(
        "v-card-text",
        [
          _c("v-text-field", {
            attrs: { label: "Recipients Email", type: "email" },
            model: {
              value: _vm.emailInfo.emailAddress,
              callback: function ($$v) {
                _vm.$set(_vm.emailInfo, "emailAddress", $$v)
              },
              expression: "emailInfo.emailAddress",
            },
          }),
          _c("v-text-field", {
            attrs: { label: "Subject", type: "text" },
            model: {
              value: _vm.emailInfo.emailSubject,
              callback: function ($$v) {
                _vm.$set(_vm.emailInfo, "emailSubject", $$v)
              },
              expression: "emailInfo.emailSubject",
            },
          }),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.initialMessage) } }),
          _c("v-textarea", {
            staticClass: "mt-2",
            attrs: { outlined: "", label: "Add to Email Message" },
            model: {
              value: _vm.personalMessage,
              callback: function ($$v) {
                _vm.personalMessage = $$v
              },
              expression: "personalMessage",
            },
          }),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { color: "error", outlined: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close-email-dialog")
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _c(
            "v-btn",
            {
              attrs: {
                color: "success",
                disabled: _vm.emailInfo.emailAddress.length === 0,
              },
              on: {
                click: function ($event) {
                  return _vm.sendEmail()
                },
              },
            },
            [_vm._v("Send Email")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }